// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 725 ? "react-syntax-highlighter/refractor-import" : chunkId) + "." + {"453":"c9eb2f83","725":"15d7e9f8"}[chunkId] + ".chunk.js";
};